/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ResourceLeadStatus {
  StatusNew = "NEW",
  StatusProcessing = "PROCESSING",
  StatusInterviewed = "INTERVIEWED",
  StatusWorking = "WORKING",
  StatusCompleted = "COMPLETED",
  StatusRefused = "REFUSED",
}

export interface AdminEmployee {
  candidateID?: string;
  coordinator?: string;
  director?: string;
  employeeID?: string;
  facility?: string;
  fullName?: string;
  home_city?: string;
  individualID?: string;
  lastLoginAt?: string;
  lastLoginCity?: string;
  phone?: string;
  position?: string;
  state?: string;
  support_manager?: string;
  userID?: string;
}

export interface AdminEmployeeFilters {
  /** Координаторы */
  coordinators?: CommonFilter[];
  /** Директоры */
  directors?: CommonFilter[];
  /** Объекты */
  facilities?: CommonFilter[];
  /** Должности */
  positions?: CommonFilter[];
  /** Менеджеры сопровождения */
  support_managers?: CommonFilter[];
}

export interface AdminEmployeeOffsetPaginated {
  pagination?: ResourcePaginationOffsetMeta;
  result?: AdminEmployee[];
}

export interface AdminFacility {
  address?: string;
  city?: string;
  coordinator?: string;
  description?: string;
  director?: string;
  employee_count?: number;
  id?: string;
  is_customer_questionnaire_required?: boolean;
  name?: string;
  support_manager?: string;
}

export interface AdminFacilityFilters {
  /** Города */
  cities?: CommonFilter[];
  /** Координаторы */
  coordinators?: CommonFilter[];
  /** Директоры */
  directors?: CommonFilter[];
  /** Регионы */
  regions?: CommonFilter[];
  /** Менеджеры сопровождения */
  support_managers?: CommonFilter[];
}

export interface AdminFacilityOffsetPaginated {
  pagination?: ResourcePaginationOffsetMeta;
  result?: AdminFacility[];
}

export interface AuthnChangePhoneRequest {
  birthdate: string;
  new_phone: string;
  passport_number: string;
}

export interface AuthnCodeBody {
  code?: string;
}

export interface AuthnFullNameBody {
  family_name?: string;
  name?: string;
  patronymic?: string;
}

export interface AuthnPhoneBody {
  /**
   * Страна
   * @default "RU"
   */
  country?: string;
  /** Номер телефона для проверки (с семёркой без спецсимволов) */
  phone?: string;
}

export interface AuthnTokenPair {
  /** Токен доступа */
  accessToken: string;
  /** Токен обновления токена доступа */
  refreshToken: string;
}

export interface AuthnTokenRefresh {
  /** Токен обновления токена доступа */
  refreshToken: string;
}

export interface AuthnUserCredentials {
  /** Код страны, нужен вместе с телефоном */
  country?: string;
  /** Email */
  email?: string;
  /** Пароль */
  password: string;
  /** Номер телефона */
  phone?: string;
}

export interface BannerAudience {
  employmentStatuses?: string[];
  minAppVersion?: string;
  platforms?: string[];
}

export interface BannerCarousel {
  aspectRatio?: string;
  autoScrollSeconds?: number;
  loop?: boolean;
}

export interface BannerListResponse {
  items?: BannerModel[];
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface BannerModel {
  allProjects?: boolean;
  audience?: BannerAudience;
  createdAt?: string;
  dismissible?: boolean;
  endsAt?: string;
  id?: string;
  imageUrl?: string;
  isActive?: boolean;
  landingUrl?: string;
  placements?: string[];
  priority?: number;
  projectIds?: string[];
  projects?: BannerProject[];
  reappearAfterDays?: number;
  startsAt?: string;
  title?: string;
  updatedAt?: string;
}

export interface BannerMyResponse {
  banners?: BannerModel[];
  carousel?: BannerCarousel;
  configVersion?: number;
}

export interface BannerPriorityRequest {
  /** @example 250 */
  priority?: number;
}

export interface BannerProject {
  id?: string;
  name?: string;
}

export interface BannerProjectListResponse {
  items?: BannerProject[];
  total?: number;
}

export interface BannerToggleRequest {
  /** @example true */
  isActive?: boolean;
}

export interface BannerUploadResponse {
  height?: number;
  imageUrl?: string;
  width?: number;
}

export interface BannerWriteRequest {
  allProjects?: boolean;
  audience?: BannerAudience;
  dismissible?: boolean;
  endsAt?: string;
  imageUrl: string;
  isActive?: boolean;
  landingUrl?: string;
  /** @minItems 1 */
  placements: string[];
  /** @min 0 */
  priority?: number;
  projectIds?: string[];
  reappearAfterDays?: number;
  startsAt?: string;
  title: string;
}

export interface CommonFilter {
  key?: string;
  value?: string;
}

export interface ResourceLeadModelNew {
  birthdate?: string;
  candidate_id?: string;
  citizenship?: string;
  /** @example "2006-01-02T15:04:05Z" */
  created_at?: string;
  first_name: string;
  last_name?: string;
  patronymic?: string;
  phone: string;
  /** @example "+7 (987) 654-32-10" */
  phone_foreign?: string;
  recommended_by_candidate_id?: string;
  refusal_reason?: string;
  /** @example "NEW" */
  status?: ResourceLeadStatus;
}

export interface ResourcePaginationOffsetMeta {
  /** Максимальное количество записей в ответе */
  limit?: number;
  /** Количество записей, которые были пропущены в выборке из базы данных */
  offset?: number;
  /** Общее количество записей в базе данных по этому запросу */
  total?: number;
}

export interface InternalServiceRestGlobalErrorHandlerResp {
  error?: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title Digital Personnel API
 * @version 0.1
 * @contact Никита Зотов <nikita.zotov@hrb.software>
 *
 * Документация Swagger к API для мобильного приложения
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  admin_panel = {
    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerList
     * @summary Получить список баннеров
     * @request GET:/admin/banners
     * @secure
     */
    adminBannerList: (
      query?: {
        /**
         * Страница
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Размер страницы
         * @min 1
         * @max 100
         * @default 20
         */
        pageSize?: number;
        /** Размещение */
        placement?: "profile" | "calendar" | "prepayment";
        /** Платформа */
        platform?: "android" | "ios" | "web";
        /** Статус */
        status?: "active" | "inactive" | "scheduled" | "expired";
        /** Поиск по названию */
        search?: string;
        /**
         * Сортировка
         * @default "-priority"
         */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BannerListResponse,
        InternalServiceRestGlobalErrorHandlerResp
      >({
        path: `/admin/banners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerCreate
     * @summary Создать баннер
     * @request POST:/admin/banners
     * @secure
     */
    adminBannerCreate: (
      request: BannerWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerModel, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerCarouselGet
     * @summary Получить настройки карусели
     * @request GET:/admin/banners/carousel-settings
     * @secure
     */
    adminBannerCarouselGet: (params: RequestParams = {}) =>
      this.request<BannerCarousel, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners/carousel-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerCarouselPut
     * @summary Обновить настройки карусели
     * @request PUT:/admin/banners/carousel-settings
     * @secure
     */
    adminBannerCarouselPut: (
      request: BannerCarousel,
      params: RequestParams = {},
    ) =>
      this.request<BannerCarousel, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners/carousel-settings`,
        method: "PUT",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerMeta
     * @summary Получить метаданные баннеров
     * @request GET:/admin/banners/meta
     * @secure
     */
    adminBannerMeta: (params: RequestParams = {}) =>
      this.request<
        Record<string, any>,
        InternalServiceRestGlobalErrorHandlerResp
      >({
        path: `/admin/banners/meta`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerProjects
     * @summary Получить проекты для таргетирования баннера
     * @request GET:/admin/banners/projects
     * @secure
     */
    adminBannerProjects: (
      query?: {
        /** Поиск по названию проекта */
        search?: string;
        /**
         * Максимальное число проектов
         * @min 1
         * @max 100
         * @default 50
         */
        limit?: number;
        /**
         * Смещение для догрузки проектов
         * @min 0
         * @default 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BannerProjectListResponse,
        InternalServiceRestGlobalErrorHandlerResp
      >({
        path: `/admin/banners/projects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerUpload
     * @summary Загрузить изображение баннера
     * @request POST:/admin/banners/upload-image
     * @secure
     */
    adminBannerUpload: (
      data: {
        /**
         * Изображение PNG, JPEG или WebP до 2 МБ
         * @format binary
         */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BannerUploadResponse,
        InternalServiceRestGlobalErrorHandlerResp
      >({
        path: `/admin/banners/upload-image`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerGet
     * @summary Получить баннер
     * @request GET:/admin/banners/{id}
     * @secure
     */
    adminBannerGet: (id: string, params: RequestParams = {}) =>
      this.request<BannerModel, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerUpdate
     * @summary Обновить баннер
     * @request PUT:/admin/banners/{id}
     * @secure
     */
    adminBannerUpdate: (
      id: string,
      request: BannerWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerModel, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners/${id}`,
        method: "PUT",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerDelete
     * @summary Удалить баннер
     * @request DELETE:/admin/banners/{id}
     * @secure
     */
    adminBannerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerPriority
     * @summary Изменить приоритет баннера
     * @request PATCH:/admin/banners/{id}/priority
     * @secure
     */
    adminBannerPriority: (
      id: string,
      request: BannerPriorityRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerModel, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners/${id}/priority`,
        method: "PATCH",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name AdminBannerToggle
     * @summary Включить или выключить баннер
     * @request POST:/admin/banners/{id}/toggle
     * @secure
     */
    adminBannerToggle: (
      id: string,
      request: BannerToggleRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerModel, InternalServiceRestGlobalErrorHandlerResp>({
        path: `/admin/banners/${id}/toggle`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-panel
     * @name MyBanners
     * @summary Получить доступные пользователю баннеры
     * @request GET:/my/banners
     * @secure
     */
    myBanners: (params: RequestParams = {}) =>
      this.request<BannerMyResponse, InternalServiceRestGlobalErrorHandlerResp>(
        {
          path: `/my/banners`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),
  };
  admin = {
    /**
     * @description Возвращает перечень кандидатов из базы API согласно указанным в запросе фильтрам
     *
     * @tags admin
     * @name DashboardEmployeeList
     * @summary Получить список кандидатов
     * @request GET:/dashboard/employees
     * @secure
     */
    dashboardEmployeeList: (
      query?: {
        /** Поисковой запрос */
        q?: string;
        /** Город ??? */
        city?: string;
        /**
         * Дата ОТ
         * @example ""2001-01-21T10:42:57+03:00""
         */
        dateFrom?: string;
        /**
         * Дата ДО
         * @example ""2001-01-21T10:42:57+03:00""
         */
        dateTo?: string;
        /** Статус */
        state?: string;
        /** Должность */
        position?: string;
        /** Объект */
        facility?: string;
        /** Оп. Директор */
        director?: string;
        /** Менеджер сопровождения */
        support_manager?: string;
        /**
         * Максимальное количество записей в ответе
         * @min 1
         * @max 100
         */
        limit?: number;
        /**
         * Количество записей, которые будут пропущены в выборке из базы данных
         * @min 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminEmployeeOffsetPaginated[], any>({
        path: `/dashboard/employees`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает .xlsx файл с сотрудниками из базы API согласно указанным в запросе фильтрам
     *
     * @tags admin
     * @name DashboardEmployeeExportExcel
     * @summary Получить .xlsx с сотрудниками
     * @request GET:/dashboard/employees/export/excel
     * @secure
     */
    dashboardEmployeeExportExcel: (
      query?: {
        /** Поисковой запрос */
        q?: string;
        /** Город ??? */
        city?: string;
        /**
         * Дата ОТ
         * @example ""2001-01-21T10:42:57+03:00""
         */
        dateFrom?: string;
        /**
         * Дата ДО
         * @example ""2001-01-21T10:42:57+03:00""
         */
        dateTo?: string;
        /** Статус */
        state?: string;
        /** Должность */
        position?: string;
        /** Объект */
        object?: string;
        /** Оп. Директор */
        director?: string;
        /** Менеджер сопровождения */
        support_manager?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/dashboard/employees/export/excel`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Возвращает перечень доступных фильтров
     *
     * @tags admin
     * @name DashboardEmployeeFilters
     * @summary Получить список доступных фильтров для панели управления
     * @request GET:/dashboard/employees/filters
     * @secure
     */
    dashboardEmployeeFilters: (params: RequestParams = {}) =>
      this.request<AdminEmployeeFilters[], any>({
        path: `/dashboard/employees/filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает перечень объектов из базы API согласно указанным в запросе фильтрам
     *
     * @tags admin
     * @name DashboardFacilityList
     * @summary Получить список объектов
     * @request GET:/dashboard/facilities
     * @secure
     */
    dashboardFacilityList: (
      query?: {
        /** Поисковой запрос */
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminFacilityOffsetPaginated[], any>({
        path: `/dashboard/facilities`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает .xlsx файл с объектами из базы API согласно указанным в запросе фильтрам
     *
     * @tags admin
     * @name DashboardFacilityExportExcel
     * @summary Получить .xlsx с объектами
     * @request GET:/dashboard/facilities/export/excel
     * @secure
     */
    dashboardFacilityExportExcel: (
      query?: {
        /** Поисковой запрос */
        q?: string;
        /**
         * Максимальное количество записей в ответе
         * @min 1
         * @max 100
         */
        limit?: number;
        /**
         * Количество записей, которые будут пропущены в выборке из базы данных
         * @min 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/dashboard/facilities/export/excel`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Получить список доступных фильтров для панели управления объектами
     *
     * @tags admin
     * @name DashboardFacilityFilters
     * @summary Получить фильтры по объектам
     * @request GET:/dashboard/facilities/filters
     * @secure
     */
    dashboardFacilityFilters: (params: RequestParams = {}) =>
      this.request<AdminFacilityFilters[], any>({
        path: `/dashboard/facilities/filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  authn = {
    /**
     * @description Аутентифицирует пользователя в приложении
     *
     * @tags authn
     * @name Login
     * @summary Аутентифицировать пользователя
     * @request POST:/login
     */
    login: (message: AuthnUserCredentials, params: RequestParams = {}) =>
      this.request<AuthnTokenPair, any>({
        path: `/login`,
        method: "POST",
        body: message,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Меняет номер телефона пользователя в БД и в 1С
     *
     * @tags authn
     * @name ChangePhone
     * @summary Сменить номер
     * @request POST:/login/change-phone
     */
    changePhone: (
      message: AuthnChangePhoneRequest,
      params: RequestParams = {},
    ) =>
      this.request<string[], any>({
        path: `/login/change-phone`,
        method: "POST",
        body: message,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Подтверждает имя пользователя. Если оно корректно, то меняет номер телефона сотрудника в БД и в 1С
     *
     * @tags authn
     * @name ChangePhoneConfirmName
     * @summary Подтведить имя пользователя
     * @request POST:/login/change-phone/confirm-name
     */
    changePhoneConfirmName: (
      query: {
        /** Имя */
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/login/change-phone/confirm-name`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Аутентифицирует пользователя, если в БД есть пользователь с таким телефоном и именем
     *
     * @tags authn
     * @name ConfirmName
     * @summary Подтведить ФИО пользователя
     * @request POST:/login/confirm/name
     */
    confirmName: (message: AuthnFullNameBody, params: RequestParams = {}) =>
      this.request<AuthnTokenPair, any>({
        path: `/login/confirm/name`,
        method: "POST",
        body: message,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Аутентифицирует пользователя, если код верный и если один такой пользователь есть в БД
     *
     * @tags authn
     * @name ConfirmPhone
     * @summary Подтведить код аутентификации
     * @request POST:/login/confirm/phone
     */
    confirmPhone: (message: AuthnCodeBody, params: RequestParams = {}) =>
      this.request<AuthnTokenPair, string>({
        path: `/login/confirm/phone`,
        method: "POST",
        body: message,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Если указанный номер существует в БД, то на него запрашивается флеш-колл
     *
     * @tags authn
     * @name RequestFlashCall
     * @summary Запросить флеш-колл
     * @request POST:/login/phone
     */
    requestFlashCall: (message: AuthnPhoneBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/login/phone`,
        method: "POST",
        body: message,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Если указанный номер существует в БД, то на него запрашивается СМС. Работает только после запроса флеш-колла
     *
     * @tags authn
     * @name RequestSms
     * @summary Запросить СМС
     * @request POST:/login/sms
     */
    requestSms: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/login/sms`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Блокирует рефреш токен от повторного использования
     *
     * @tags authn
     * @name Logout
     * @summary Заблокировать рефреш токен
     * @request POST:/logout
     * @secure
     */
    logout: (message: AuthnTokenRefresh, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/logout`,
        method: "POST",
        body: message,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Обновляет токен доступа пользователя в приложении
     *
     * @tags authn
     * @name Refresh
     * @summary Обновить токен доступа
     * @request POST:/refresh
     */
    refresh: (message: AuthnTokenRefresh, params: RequestParams = {}) =>
      this.request<AuthnTokenPair, any>({
        path: `/refresh`,
        method: "POST",
        body: message,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создаёт заявку на регистрацию пользователя в приложении
     *
     * @tags authn
     * @name Register
     * @summary Создать заявку на регистрацию пользователя
     * @request POST:/register
     */
    register: (message: ResourceLeadModelNew, params: RequestParams = {}) =>
      this.request<AuthnTokenPair, any>({
        path: `/register`,
        method: "POST",
        body: message,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
